import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import ShortTransactionHistory from './ShortTransactionHistory';
import Advertisement from './Advertisement';
import Paper from '@mui/material/Paper';
import CardSlick from './CardSlick';

const paperStyle = { my: { xs: 1, md: 1 }, p: { xs: 2, md: 3 }};
const container = { mt: 2 };
export default function Main() {
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Grid item xs={12}>
            <Paper variant="outlined" sx={paperStyle}>
                <Grid container>
                    <CardSlick></CardSlick>
                </Grid>
            </Paper>

            <Grid item xs={12}>
                <Grid container spacing={gridSpacing} sx={container}>
                    <Grid item xs={12} sm={6} md={8}>
                        <Advertisement></Advertisement>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <ShortTransactionHistory isLoading={isLoading} />
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );
}